import { render } from "./MenuEconomicTools.vue?vue&type=template&id=5133cc33&scoped=true&ts=true"
import script from "./MenuEconomicTools.vue?vue&type=script&lang=ts"
export * from "./MenuEconomicTools.vue?vue&type=script&lang=ts"

import "./MenuEconomicTools.vue?vue&type=style&index=0&id=5133cc33&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/platform/platform/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5133cc33"]])

export default __exports__